import { LogsService } from './../../../shared/services/logs.service';
import { UtilitiesService } from './../../../shared/services/utilities.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-api-logs',
  templateUrl: './api-logs.component.html',
  styleUrls: ['./api-logs.component.scss']
})
export class ApiLogsComponent implements OnInit {
  public userData: any;
  public logs: any[];
  public filters: any;
  public pagination: any;
  public methods: any[] = [];

  public cardNumberEditorOptions: any;

  constructor(
    private utilitiesService: UtilitiesService,
    private logsService: LogsService
  ) {
    this.userData = this.utilitiesService.getUserData();
    console.log(this.userData);

    //Init methods
    this.methods.push({name:'FondearTarjeta'});
    this.methods.push({name:'TraspasoTarjetas'});
    this.methods.push({name:'ActualizarDatosCliente'});

    // CardNumber editor options
    this.cardNumberEditorOptions = {
      mask: '0000  0000  0000  0000',
      maskRules: { 'X': /[0-9]/ }
    };

    // Pagination
    this.pagination = {
      page: 0,
      pageSize: 10,
      pageSizeOptions: [10,20,30,50,100]
    }

    //Filters
    this.filters = {
      dateStart: new Date(),
      dateEnd: new Date()
    }
  }

  ngOnInit() {
    this.filters.dateStart.setDate(new Date().getDate() - 10);
    this.filters.dateStart.setHours(0,0,0);
    this.filters.dateEnd.setHours(23,29,59);
    console.log(this.filters);
    this.getLogsCacao();
  }

  getLogsCacao(e?) {
    this.filters.dateStart.toLocaleString();
    this.filters.dateEnd.toLocaleString();
    this.logsService.getLogsCacao(0,null,this.filters.dateStart,this.filters.dateEnd,this.filters.method,this.filters.cardNumber,null,true).toPromise()
    .then((result: any) => {
      console.log(result);
      this.logs = result && result.data ? result.data : [] ;
    })
    .catch(err => {
      console.log(err);
    });
  }

}
